import { MaterialTextField } from '@/shared/components/form/MaterialFormElements';

const renderTextField = ({
	input,
	label,
	meta,
	children,
	select,
	multiline,
	error,
	maxLength,
	options,
	isMulti,
	onChange, // You're passing this from props
	readOnly,
	defaultValue,
	endAdornment,
	variant,
	onBlur,
	placeholder,
	required,
	...props
}) => {
	const showError = meta?.touched && meta?.error;
	return (
		<MaterialTextField
			label={label}
			required={required}
			helperText={showError ? meta.error : ''} // Display error message
			error={error || showError}
			value={input?.value}
			select={!!select}
			placeholder={placeholder}
			multiline={multiline}
			defaultValue={defaultValue || input?.defaultValue} // Make sure defaultValue works
			name={input?.name}
			options={options}
			isMulti={isMulti}
			onChange={onChange || input?.onChange} // Safeguard against missing onChange
			onBlur={input?.onBlur || onBlur}
			maxLength={maxLength}
			InputProps={{
				readOnly,
				maxLength,
				endAdornment,
			}}
			variant={variant}
			{...props}
		>
			{children}
		</MaterialTextField>
	);
};

export default renderTextField;
